module.exports = __webpack_public_path__ + "static/media/mv-fullmoon_3.1c58b14c.png";